const REQUIRED_LEVEL = {
  BASIC: 10,
  PLUS: 20,
  PREMIUM: 30,
};

const isBasicView = (accessLevel) => REQUIRED_LEVEL.BASIC === accessLevel;

const isPlusView = (accessLevel) => REQUIRED_LEVEL.PLUS === accessLevel;

const isPremiumView = (accessLevel) => REQUIRED_LEVEL.PREMIUM === accessLevel;

export { isBasicView, isPlusView, isPremiumView, REQUIRED_LEVEL };



// WEBPACK FOOTER //
// ./src/utilities/access.js